import { useEffect, useState } from "react";

type CheckIds = {
  id: number;
  checked: boolean;
  disabled?: boolean;
};

export default function useCheckTable(
  ids: { id: number; disabled: boolean }[]
) {
  const [checkedIds, setCheckedIds] = useState<CheckIds[]>([]);

  useEffect(() => {
    setCheckedIds((prev) => {
      return ids.map((item) => {
        const existing = prev.find((el) => el.id === item.id);
        return {
          id: item.id,
          disabled: item?.disabled,
          checked: existing?.checked ?? false,
        };
      });
    });
  }, [ids]);

  const handleCheckAll = (checked: boolean) => {
    setCheckedIds((prev) =>
      prev.map((el) => (el.disabled ? el : { ...el, checked }))
    );
  };

  const handleCheck = (checked: boolean, id: number, disabled?: boolean) => {
    setCheckedIds((prev) =>
      prev.map((el) =>
        el.id === id
          ? {
              ...el,
              checked,
              ...(disabled !== undefined ? { disabled } : {}),
            }
          : el
      )
    );
  };

  const selectedIds = checkedIds.filter((el) => el.checked).map((el) => el.id);

  return {
    checkedIds,
    selectedIds,
    handleCheck,
    handleCheckAll,
  };
}
